"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function nonRepeatedChars(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    subStr = _ref.subStr;
  var isString = typeof value === 'string';
  var isNumber = typeof value === 'number';
  var hasValue = !!value;
  var isValidType = !hasValue || !isString || !isNumber;
  if (!isValidType) return new classes_1.ValidationResult(true);
  var stringfied = String(value);
  var shouldCheckSubstr = !!subStr && !Number.isNaN(Number(subStr)) && subStr !== 1;
  if (shouldCheckSubstr && !!subStr) {
    var regexToCheck = new RegExp("(.)\\1{".concat(subStr - 1, ",}"));
    var charRepeats = regexToCheck.test(stringfied);
    var _isValid = !charRepeats;
    return new classes_1.ValidationResult(_isValid);
  }
  var repeatedCharsRegex = /^(.)\1+$/;
  var hasOnlyTheSameChar = repeatedCharsRegex.test(stringfied);
  var isValid = !hasOnlyTheSameChar;
  var message = isValid ? '' : 'O campo não deve conter caracteres repetidos';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(nonRepeatedChars);